import React from "react";
import classes from "./newInspection.module.css";
import { useState, useEffect } from "react";
import { notification } from "antd";
import Input from "../../../Auth/Input";
import Button from "../../../Auth/button";
import { Select } from "antd";
import axios from "../../../../Axios";
import { useHistory } from "react-router";
import { geolocated } from "react-geolocated";

const { Option } = Select;
const openNotificationWithIcon = (type, message, description) => {
  notification[type]({
    message: `${message}`,
    description: `${description}`,
  });
};

const intialState = {
  auditorName: localStorage.getItem("name"),
  location: null,
  auditTemplate: null,
  auditiName: null,
  description: null,
};

const initialError = {
  location: false,
  auditTemplate: false,
  auditiName: false,
  description: false,
};

const NewInspection = () => {
  const history=useHistory();
  const [templatesData, setTemplates] = useState({});
  useEffect(() => {
    const FetchFunc = async () => {
      const fetchData = await axios.post("/templates/fetch", {
        fetchType: 0,
        fetchItems: ["title"],
      });
      const { payload } = fetchData.data;
      const tempTemplates = {};

      payload.map((template) => {
        return (tempTemplates[template["_id"]] = {
          title: template.title,
        });
      });

      setTemplates(tempTemplates);
    };
    FetchFunc();
  }, []);

  const options = Object.keys(templatesData).map((cur) => (
    <Option id={cur} key={cur} value={cur} title={templatesData[cur].title}>
      {templatesData[cur].title}
    </Option>
  ));

  const [state, setState] = useState({ ...intialState });
  const [errors, setErrors] = useState({ ...initialError });
  const { auditorName, location, auditTemplate, auditiName, description } =
    state;

  const [isInValid, setIsInValid] = useState(false);

  useEffect(() => {
    //err handeling

    if (
      auditorName == null ||
      location == null ||
      auditTemplate == null ||
      auditiName == null ||
      description == null
    ) {
      setIsInValid(true);
    } else setIsInValid(false);
  }, [auditorName, location, auditTemplate, auditiName, description]);

  const clickHandler = () => {
    history.push('audit-template?id='+auditTemplate)
  };
  const changeHandler = (e) => {
    let { name, value } = e.target;
    let inputValid = false;
    if (value.length > 0) inputValid = true;
    setErrors(() => ({ ...errors, [name]: !inputValid }));
    if (value === "") value = null;

    setState(() => ({ ...state, [name]: value }));
  };
  const onChange = (value) => {
    setState(() => ({ ...state, auditTemplate: value }));
  };
  const locationUpdate = (e) => {
    navigator.geolocation.getCurrentPosition(function(position) {
      setState(() => ({ ...state, location:position}));
    },
      function(error) {
        console.error("Error Code = " + error.code + " - " + error.message);
      }
    );
    
  };

  return (
    <div>
      <h2>Start New Inspection</h2>
      <hr />
      <div className={classes.NewInspection}>
        <div className={classes.card}>
          <Input name="auditorName" value={auditorName} disabled={true} />
          <Input
            onChange={locationUpdate}
            name="location"
            value={location ? "Location Updated" : "Please Allow Location"}
            err={errors["location"]}
            errMsg="This a Mandatory Field"
            type="text"
            placeholder="Location"
          />
          <Select
            showSearch
            placeholder={
              <div className={classes.placeholder}>Select Audit Template</div>
            }
            optionFilterProp="children"
            name="auditTemplate"
            onChange={onChange}
            className={classes.search}
            size="large"
            
            // onFocus={onFocus}
            // onBlur={onBlur}
            // onSearch={onSearch}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {options}
          </Select>
          ,
          <Input
            onChange={changeHandler}
            name="auditiName"
            value={auditiName ? auditiName : ""}
            err={errors["auditiName"]}
            errMsg="This a Mandatory Field"
            type="text"
            placeholder="Auditee Name"
          />
          <Input
            onChange={changeHandler}
            name="description"
            value={description ? description : ""}
            err={errors["description"]}
            errMsg="This a Mandatory Field"
            type="text"
            placeholder="Audit Description"
          />
          <Button onClick={clickHandler} disabled={isInValid}>
            Start Inspection
          </Button>
        </div>
        <div className={classes.imgHolder}>
          <img src="/images/newInspection.svg" className={classes.img} />
        </div>
      </div>
    </div>
  );
};

export default NewInspection;
